import { Link } from "@faire/slate/components/link";
import { Color } from "@faire/web/slate/Color";
import * as React from "react";

interface IActionBase {
  text: string;
}

interface IActionALink extends IActionBase {
  action: { href: string; to?: never; onClick?: () => void };
}

interface IActionLink extends IActionBase {
  action: { href?: never; to: string; onClick?: () => void };
}

interface IActionButton extends IActionBase {
  action: { href?: never; to?: never; onClick: () => void };
}

export type IAction = IActionALink | IActionLink | IActionButton;

export const renderTextAction = (
  actionOptions?: IAction,
  options?: { textColor?: Color }
): React.ReactNode => {
  if (!actionOptions) {
    return null;
  }

  const destination = actionOptions.action.href ?? actionOptions.action.to;
  const action = destination ? (
    <Link
      linkTo={destination}
      onClick={actionOptions.action.onClick}
      target={actionOptions.action.href ? "_blank" : undefined}
    >
      {actionOptions.text}
    </Link>
  ) : (
    <Link as="button" onClick={actionOptions.action.onClick}>
      {actionOptions.text}
    </Link>
  );

  if (!options?.textColor) {
    return action;
  }

  return <span style={{ color: options.textColor }}>{action}</span>;
};
